
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"46","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".5","y":".5","width":"45","height":"31","rx":"5.5","fill":"#fff","stroke":"#EEE"}}),_c('path',{attrs:{"d":"M17.999 22a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM26.25 22a1.5 1.5 0 100-3 1.5 1.5 0 000 3z","stroke":"#333","stroke-width":"1.5","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M29.249 20.5v0a1.5 1.5 0 001.5-1.5v-3a1.5 1.5 0 00-1.5-1.5h-13.5a1.5 1.5 0 00-1.5 1.5v3a1.5 1.5 0 001.5 1.5h.75","stroke":"#333","stroke-width":"1.5","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M27.749 14.5l-4.06-4.06a1.5 1.5 0 00-1.061-.44h-2.952a1.5 1.5 0 00-1.342.83L16.5 14.5","stroke":"#333","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M19.501 20.5h3M20.25 14.5v-1.875","stroke":"#333","stroke-width":"1.5","stroke-linecap":"round"}})])
          )
        }
      }
    